import {
	ToggleButton,
	ToggleButtonGroup,
	ToggleButtonGroupProps
} from '@mui/material';
import React from 'react';

const ToggleButtonOptions: React.FC<IToggleButtonOptionsProps> = ({
	value,
	onChange,
	options
}) => (
	<ToggleButtonGroup
		color="primary"
		value={value}
		size="small"
		exclusive
		onChange={onChange}
	>
		{(options || []).map((o) => (
			<ToggleButton key={o.value} value={o.value}>
				{o.label}
			</ToggleButton>
		))}
	</ToggleButtonGroup>
);

export interface IToggleButtonOptionsProps extends ToggleButtonGroupProps {
	value: any;
	options: { value: any; label: string }[];
}

export default ToggleButtonOptions;
